import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { ActionButtonIcons } from '../shared/components/action-button/action-button-icons';
import { LoaderButtonState } from '../shared/components/button/button-status';
import { DateRange } from '../shared/components/datepicker/calendar/DateRange';
import { ConfirmModalComponent } from '../shared/components/modal/confirm-modal/confirm-modal.component';
import { MessageModalComponent } from '../shared/components/modal/message-modal/message-modal.component';
import { ModalService } from '../shared/components/modal/modal.service';
import { SelectedDeselected } from '../shared/interfaces/SelectedDeselected';
import { ValuePair } from '../shared/interfaces/ValuePair';

@Component({
  selector: 'ls-components-showcase',
  templateUrl: 'components-showcase.component.html',
  styleUrls: ['components-showcase.component.scss']
})
export class ComponentsShowcaseComponent implements OnInit {
  public multiSelectItems: Array<ValuePair> = [
    {
      value: 'A',
      name: 'Location A'
    },
    {
      value: 'B',
      name: 'Location B'
    },
    {
      value: 'C',
      name: 'Location C'
    },
    {
      value: 'D',
      name: 'Location D'
    }
  ];

  public singleSelectItems: Array<ValuePair> = [
    {
      value: 'A',
      name: 'Location A'
    },
    {
      value: 'B',
      name: 'Location B'
    },
    {
      value: 'C',
      name: 'Location C'
    },
    {
      value: 'D',
      name: 'Location D'
    }
  ];

  public switchTableItems: Array<ValuePair> = [
    {
      value: {
        title: 'Edit Floors',
        description: `Allows users to edit floors, tables and chairs on the floor plan editor.`,
        disabled: true
      },
      name: 'deselected'
    },
    {
      value: {
        title: 'Edit Floors',
        description:
          'Allows users to edit floors, tables and chairs on the floor plan editor.',
        disabled: false
      },
      name: 'deselected'
    },
    {
      value: {
        title: 'Edit Floors',
        description:
          'Allows users to edit floors, tables and chairs on the floor plan editor.',
        disabled: false
      },
      name: 'deselected'
    },
    {
      value: {
        title: 'Edit Floors',
        description:
          'Allows users to edit floors, tables and chairs on the floor plan editor.',
        class: 'right__items--optional',
        disabled: true
      },
      name: 'selected'
    },
    {
      value: {
        title: 'Edit Floors',
        description:
          'Allows users to edit floors, tables and chairs on the floor plan editor.',
        disabled: false
      },
      name: 'deselected'
    },
    {
      value: {
        title: 'Edit Floors',
        description:
          'Allows users to edit floors, tables and chairs on the floor plan editor.',
        class: 'right__items--standard',
        disabled: false
      },
      name: 'selected'
    }
  ];

  public switchTableTitles: SelectedDeselected = {
    deselected: 'Disabled Rights',
    selected: 'Enabled Rights'
  };

  public switchTableLegendItems: Array<ValuePair> = [
    {
      name: 'Extra rights',
      value: 'right__items--optional'
    },
    {
      name: 'Rights added from role',
      value: 'right__items--standard'
    }
  ];

  public pagination: any = {
    totalPages: 20,
    showPages: 5,
    showFirstLast: true,
    showNextPrevious: true
  };

  public daterange: DateRange = new DateRange(
    moment()
      .add(-1, 'week')
      .startOf('hour'),
    moment()
      .add(1, 'week')
      .startOf('hour')
  );
  public currentState: LoaderButtonState = LoaderButtonState.NONE;
  public actionButtonIcons: typeof ActionButtonIcons;
  public actionClicked: ActionButtonIcons;
  public textAreaText = 'Some text';
  public textAreaLabel = 'Text area label';
  public textAreaPlaceHolder = 'A placeHolder maximum 50 chars';
  public textAreaMax = 50;
  public reactiveIpForm: FormGroup;

  constructor(private modal: ModalService, private formBuilder: FormBuilder) {
    this.reactiveIpForm = this.formBuilder.group({
      ipAddressRequired: ''
    });
  }

  public ngOnInit(): void {
    this.actionButtonIcons = ActionButtonIcons;
  }

  public showPopup(popup: string, title: string, message: string): void {
    if (popup === 'message') {
      this.modal.open(MessageModalComponent, {
        title: title,
        message: message
      });
    } else {
      this.modal.open(ConfirmModalComponent, {
        title: title,
        message: message
      });
    }
  }

  public showMultiplePopups(quantity: number): void {
    for (let i = 0; i < quantity; i++) {
      const modalIndex: number = i + 1;
      console.log(`Opening popup ${modalIndex}`);
      this.modal
        .open(i % 2 === 0 ? MessageModalComponent : ConfirmModalComponent, {
          title: `Modal ${modalIndex}`,
          message: `Still ${modalIndex} to go!`
        })
        .subscribe(() => {
          console.log(`${modalIndex} closed`);
        });
    }
  }

  public dateChanged(range: DateRange): void {
    console.log('date updated', range);
  }

  public nextState(state: LoaderButtonState): void {
    switch (state) {
      case LoaderButtonState.DONE:
        this.currentState = LoaderButtonState.FAILED;
        break;
      case LoaderButtonState.FAILED:
        this.currentState = LoaderButtonState.NONE;
        break;
      case LoaderButtonState.LOADING:
        this.currentState = LoaderButtonState.DONE;
        break;
      default:
        this.currentState = LoaderButtonState.LOADING;
    }
  }

  public lsActionButtonClicked(action: any): void {
    this.actionClicked = action.currentTarget.title;
  }

  public primaryClicked(): void {
    alert('Primary button clicked');
  }
}
